import {
  AutomationStatus,
  MessageStatus,
  TaskStatus
} from '@dadohr/shared/domainTypes/experience';
import { Color, ColoredChipDark } from '../../../../components/ColoredChip';
import { useUnsafeTranslation } from '../../../../i18next';

const Chip = ({
  children,
  color,
  selected
}: {
  children: React.ReactNode;
  color: Color;
  selected: boolean;
}) => {
  return (
    <ColoredChipDark
      muiVariant={!selected ? 'outlined' : undefined}
      color={color}
    >
      {children}
    </ColoredChipDark>
  );
};

export const StatusChip = ({
  status,
  selected,
  count
}: {
  status: string;
  selected: boolean;
  count: number;
}) => {
  const { t } = useUnsafeTranslation();

  switch (status) {
    case MessageStatus.UPCOMING:
    case TaskStatus.NOT_STARTED:
    case AutomationStatus.UPCOMING:
      return (
        <Chip color="gray" selected={selected}>
          {t(`{{ count }} Upcoming`, { count })}
        </Chip>
      );
    case TaskStatus.RUNNING:
      return (
        <Chip color="blue" selected={selected}>
          {t(`{{ count }} Todo`, { count })}
        </Chip>
      );
    case MessageStatus.ERROR:
    case AutomationStatus.ERROR:
    case TaskStatus.LATE:
      return (
        <Chip color="red" selected={selected}>
          {status === TaskStatus.LATE
            ? t(`{{ count }} Overdue`, { count })
            : t(`{{ count }} Error`, { count })}
        </Chip>
      );
    case AutomationStatus.DONE:
    case TaskStatus.COMPLETE:
    case 'OK':
      return (
        <Chip color="green" selected={selected}>
          {status === AutomationStatus.DONE || status === TaskStatus.COMPLETE
            ? t(`{{ count }} Done`, { count })
            : t(`{{ count }} Sent`, { count })}
        </Chip>
      );
    case TaskStatus.SKIPPED:
    case AutomationStatus.SKIPPED:
    case MessageStatus.SKIPPED:
      return (
        <Chip color="darkGray" selected={selected}>
          {t(`{{ count }} Skipped`, { count })}
        </Chip>
      );
    default:
      return null;
  }
};

export const InDeliveryChip = () => {
  const { t } = useUnsafeTranslation();
  return (
    <ColoredChipDark size="small" color="yellow">
      {t('In delivery')}
    </ColoredChipDark>
  );
};
